module.exports = __webpack_public_path__ + "img/ic-visa-white.e93dce33.svg";